import type { ConfigDefaults } from 'posthog-js'

export default defineNuxtPlugin((nuxtApp) => {
    const runtimeConfig = useRuntimeConfig();
    // The public share page: an outsider's visit, and the token is in the URL
    if (window.location.pathname.startsWith('/share/')) return;
    const isLocal = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

    // Loaded after the first render instead of with the entry chunk; consumers wait on posthogReady.
    nuxtApp.hook('app:mounted', async () => {
        const { default: posthog } = await import('posthog-js');
        posthog.init(runtimeConfig.public.posthogPublicKey, {
            api_host: runtimeConfig.public.posthogHost,
            // A date string from the runtime config; posthog-js types it as the union of dates it knows.
            defaults: runtimeConfig.public.posthogDefaults as ConfigDefaults,
            person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
            // Local development: feature flags still load, but nothing is captured or recorded.
            ...(isLocal ? { opt_out_capturing_by_default: true, disable_session_recording: true, autocapture: false } : {}),
            loaded: (posthog) => {
                if (import.meta.env.MODE === 'development') posthog.debug();
            }
        });
        setPosthog(posthog);
    });
})
